var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Button',{attrs:{"label":"Save","type":"link","isBusy":_vm.isSaving,"submit":""}})}
var staticRenderFns = []

export { render, staticRenderFns }